<div class="management-form-container" *ngIf="revoteDetail$ | async as revote let i = index">
    <h2>Attributes</h2>
    <form [formGroup]="form">
        <div  class="flex-space-between-center flex-row-wrap" >
            <label class="flex-40" >Name</label>
            <mat-form-field class="flex-60" >
                <input [attr.data-testid]="'revote_name_text'" matInput required placeholder="Name"
                       formControlName="name" [readonly]="readOnlyState">
                <mat-error *ngIf="form.controls['name'].invalid && !form.controls['name'].value"> Please enter a Name </mat-error>
            </mat-form-field>
        </div>
        <div  class="flex-space-between-center flex-row-wrap" >
            <label class="flex-40" >Consumer</label>
            <mat-form-field class="flex-60" >
                <input [attr.data-testid]="'revote_consumer_text'" matInput required placeholder="Consumer" formControlName="consumer"
                    [readonly]="true">
                <mat-error *ngIf="form.controls['consumer'].invalid && !form.controls['consumer'].value"> Please enter a Consumer
                </mat-error>
            </mat-form-field>
        </div>
        <div  class="flex-space-between-center flex-row-wrap" >
            <label class="flex-40" >Open Date</label>
            <emm-effective-date-selection 
                                          source="management"
                                          [effectiveDate]="prevOpenDate"
                                          [label]="'Open Date'"
                                          (effectiveDateChange)="selectOpenDate($event)" class="flex-60">
            </emm-effective-date-selection>
        </div>
        <div  class="flex-space-between-center flex-row-wrap" >
            <label class="flex-40" >Close Date</label>
            <emm-effective-date-selection 
                                          source="management"
                                          [effectiveDate]="prevCloseDate"
                                          [label]="'Close Date'"
                                          (effectiveDateChange)="selectCloseDate($event)" class="flex-60">
            </emm-effective-date-selection>
        </div>
        <div  class="flex-space-between-center flex-row-wrap" >
            <label class="flex-40" >Effective Date</label>
            <emm-effective-date-selection 
                                          source="management"
                                          [effectiveDate]="prevEffectiveDate"
                                          [label]="'Effective Date'"
                                          (effectiveDateChange)="selectEffectiveDate($event)" class="flex-60">
            </emm-effective-date-selection>
        </div>
        <div  class="flex-space-between-center flex-row-wrap" >
            <label class="flex-40" >Categories</label>
            <mat-card-content class="flex-100" >
                <mat-list class="ml-3" style="height: 220px; overflow: scroll;">
                    <mat-list-item *ngFor="let category of categories$ | async" style="height: 40px;">
                        <mat-checkbox
                            [checked]="category.checked || selectedCategories.indexOf(category.tag) > -1"
                            [disableRipple]="readOnlyState"
                            (change)="updateAllSelected($event.checked, category.tag)">
                            {{category.name}}&nbsp;-&nbsp;{{category.tag}}
                        </mat-checkbox>
                    </mat-list-item>
                </mat-list>
            </mat-card-content>
        </div>
        <div  class="flex-space-between-center flex-row-wrap" >
            <label class="flex-40" >Locations</label>
            <mat-card appearance="outlined"  style="height: 200px; overflow: scroll" class="flex-80">
                <div *ngFor="let location of selectedLocations">
                    {{location.name}} ({{location.tag}})
                </div>
            </mat-card>
            <div  *ngIf="!readOnlyState" class="flex-7">
                <button class="add" [attr.data-testid]="'location_edit_button'" mat-icon-button matTooltip="Edit Locations"
                        (click)="editLocations()">
                    <mat-icon>edit</mat-icon>
                </button>
            </div>
        </div>
    </form>
    <div   class="flex-gap-20px flex-center flex-row" >
        <button mat-raised-button (click)="cancel()">Cancel</button>
        <button [attr.data-testid]="'update_button'" mat-raised-button (click)="submit(revote)"
                matTooltip="Update Revote"
                *ngIf="!(form.pristine || form.invalid || readOnlyState)">Update</button>
        <div *ngIf="(form.pristine || form.invalid || readOnlyState)"
            matTooltip="This revote cannot be edited because the open date has passed or the form has not been changed.">
            <button [attr.data-testid]="'update_button'" mat-raised-button (click)="submit(revote)"
                [disabled]="form.pristine || form.invalid || readOnlyState"
        >Update</button></div>
    </div>
</div>
